import { useAppDispatch } from '@/hooks/useReduxHooks';
import { updateCs } from '@/store/modules/cs';
import { Button } from '@successmode-ktp/kui';
import styled from 'styled-components';
import { useQuery } from 'react-query';
import { getChatList } from '@/api/cs';
import CsChatItem from '@/components/sideNavigation/Cs/chat/CsChatItem';
import { useState } from 'react';
import { Chat } from '@/types/cs.type';

function CsChat() {
  const dispatch = useAppDispatch();
  const [chatList, setChatList] = useState<Chat[]>([]);
  const { data } = useQuery(['ChatList'], getChatList, {
    onSuccess: (data) => {
      const chatRemovedModify = data.chats.filter(
        (chat) => chat.chatType !== 'REFUND_MODIFY',
      );
      const sortedChat = chatRemovedModify.sort(
        (a, b) =>
          Number(new Date(b.lastMessageDate)) -
          Number(new Date(a.lastMessageDate)),
      );
      setChatList(sortedChat);
    },
  });

  const onOpenNewChat = () => {
    dispatch(
      updateCs({
        isOpenChat: true,
        hasOpenChatAnimation: false,
      }),
    );
  };

  if (!data) {
    return null;
  }

  if (chatList.length === 0) {
    return (
      <NoResultWrapper>
        <NoResultText>문의 내역이 없습니다</NoResultText>
        <Button onClick={onOpenNewChat}>문의하기</Button>
      </NoResultWrapper>
    );
  }

  return (
    <>
      {data.chats.length > 0 && (
        <ChatList>
          {chatList.map((chat) => (
            <CsChatItem key={chat.id} info={chat} />
          ))}
        </ChatList>
      )}
    </>
  );
}

const NoResultWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 26px;
  padding: 0 29px;
`;

const NoResultText = styled.p`
  color: #5f6165;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
`;

const ChatList = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
`;

export default CsChat;
